<template>
  <div>
    <form class="form-box">
      <b-row class="no-gutters">
        <b-col xl="3" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">การกระจายสินค้า</h1>
        </b-col>
        <b-col xl="9" class="text-right d-flex justify-content-end">
          <InventorySectionFilter
            v-if="controlTab == 1"
            v-on:onSubmitFilter="onSubmitAllFilter"
            name="All"
            ref="inventorySectionFilter"
          />
          <InventoryBookProductFilter
            v-if="controlTab == 5"
            v-on:onSubmitCampaignFilter="onSubmitCampaignFilter"
          />
        </b-col>
      </b-row>
      <b-tabs content-class="mt-0" class="mt-3 inventory-tabs">
        <b-tab
          title="ทั้งหมด"
          :active="controlTab == 1"
          @click="selectTab(1)"
          id="tabInventoryAll"
        >
          <InventoryAll ref="inventoryAllComponent" v-if="controlTab == 1" @updateFilter="(filter)=> {$refs.inventorySectionFilter.setFilter({...filter})}" />
        </b-tab>

        <b-tab
          title="กระจายอัตโนมัติ"
          :active="controlTab == 2"
          @click="selectTab(2)"
          class="my-3"
          id="tabInventoryAuto"
        >
          <InventoryAuto v-if="controlTab == 2" />
        </b-tab>

        <b-tab
          title="คลังไม่อัตโนมัติ"
          :active="controlTab == 3"
          @click="selectTab(3)"
          class="my-3"
          id="tabInventoryOffline"
        >
          <InventoryOffline v-if="controlTab == 3" />
        </b-tab>

        <b-tab
          title="กำหนดแยกรายการสินค้า"
          :active="controlTab == 4"
          @click="selectTab(4)"
          class="my-3"
          id="tabInventoryCustom"
        >
          <InventoryCustom v-if="controlTab == 4" />
        </b-tab>

        <b-tab
          title="จองสินค้าเข้าแคมเปญ"
          :active="controlTab == 5"
          @click="selectTab(5)"
          class="my-3"
          id="tabInventoryBookProduct"
        >
          <InventoryBookProduct
            ref="inventoryCompaignComponent"
            v-if="controlTab == 5"
          />
        </b-tab>
      </b-tabs>
    </form>
  </div>
</template>

<script>
import InventoryBookProduct from "./components/inventory-campaign/InventoryBookProduct.vue";
import InventoryCustom from "./components/inventory-custom/InventoryCustom.vue";
import InventoryAuto from "./components/inventory-auto/InventoryAuto.vue";
import InventoryOffline from "./components/inventory-offline/InventoryOffline.vue";
import InventoryAll from "./components/inventory-all/InventoryAll.vue";
import InventorySectionFilter from "./components/inventory-filter/InventorySectionFilter.vue";
import InventoryBookProductFilter from "./components/inventory-filter/InventoryBookProductFilter.vue";

export default {
  components: {
    InventoryAll,
    InventoryBookProduct,
    InventoryCustom,
    InventoryOffline,
    InventoryAuto,
    InventorySectionFilter,
    InventoryBookProductFilter,
  },
  data() {
    return {
      controlTab: 0,
    };
  },
  created () {
    this.controlTab = this.$route.query.tab || 1;
  },
  methods: {
    onSubmitAllFilter(filter) {
      this.$refs.inventoryAllComponent.onSubmitFilterPanel(filter);
    },
    onSubmitCampaignFilter(filter) {
      this.$refs.inventoryCompaignComponent.getProductList(filter);
    },
    selectTab(tab) {
      this.controlTab = tab;
      this.$router.push({ path: '/inventory', 
        query: { 
          brandID: this.$route.query.brandID,
          tab: this.controlTab
        }
      }).catch(err => {});
    },
  },
};
</script>

<style scoped>
::v-deep .nav-tabs .nav-link {
  min-width: 195px;
  max-width: unset;
}
</style>
